export default {
  title: 'Order Request Detail',
  // actions: [
  //   {
  //     label: 'Edit',
  //     type: 'edit'
  //   },
  //   {
  //     label: 'Delete',
  //     type: 'delete'
  //   }
  // ],
  elements: [
    {
      type: 'detailsPanel',
      config: {
        actions: {
          fetch: {
            endpoint: 'order-requests/{id}',
            method: 'GET',
            dataPath: 'data'
          }
        },
        sections: [
          {
            fields: [
              {
                label: 'Type',
                field: 'type'
              },
              {
                label: 'Status',
                field: 'status'
              },
              {
                label: 'To Supplier',
                widget: 'card',
                main: 'supplier.screen_name',
                image: {
                  field: 'supplier.logo_url',
                  width: 40,
                  height: 40
                }
              },
              {
                label: 'From Buyer',
                field: 'buyer.display_name'
              },
              {
                label: 'Created',
                field: 'created_at',
                widget: 'datetime'
              },
              {
                label: 'Sent at',
                field: 'sent_at',
                widget: 'datetime',
                emptyVal: 'Not sent yet (draft)'
              }
            ]
          },
          {
            fields: [
              {
                label: 'Total',
                field: 'total_price'
              },
              {
                label: 'Notes',
                field: 'note',
                widget: 'htmlContent',
                lines: 10
              }
            ]
          }
        ]
      }
    },
    {
      title: 'Items in this request',
      type: 'dataTable',
      config: {
        url: 'order-request-items',
        rowActions: [],
        response: {
          mappers: {
            list: 'data'
          }
        },
        defaultParams: {
          'filter[order_request_id]': '{resourceId}'
        },
        maxHeight: 550,
        columns: [
          {
            label: 'Quantity',
            field: 'quantity',
            align: 'center'
          },
          {
            label: 'Product',
            widget: 'card',
            main: 'product.name',
            image: {
              field: 'product.listing_image_url',
              width: 80,
              height: 80
            },
            primary: {
              field: 'product.name'
            },
            secondary: {
              widget: 'identifierLabel',
              field: 'product.sku'
            }
          },
          {
            label: 'Notes',
            field: 'note'
          }
        ]
      }
    },
    {
      title: 'Messages',
      type: 'dataTable',
      config: {
        url: 'order-request-messages',
        rowActions: [],
        response: {
          mappers: {
            list: 'data'
          }
        },
        defaultParams: {
          'filter[order_request_id]': '{resourceId}'
        },
        maxHeight: 550,
        columns: [
          {
            label: 'Author',
            field: 'author.supplier',
            widget: [
              {
                if: 'author.supplier',
                then: {
                  widget: 'card',
                  main: 'author.supplier.screen_name',
                  image: {
                    field: 'author.supplier.logo_url',
                    width: 40,
                    height: 40
                  }
                }
              },
              {
                if: 'author.buyer',
                then: {
                  field: 'author.buyer.display_name'
                }
              }
            ]
          },
          {
            label: 'Message',
            field: 'message'
          },
          {
            label: 'Sent at',
            field: 'created_at',
            widget: 'datetime'
          }
        ]
      }
    }
  ]
};
